var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maximal-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 39.9,
    y1: 63.7,
    x2: 32.1,
    y2: 8.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 15.6,
    y1: 45.8,
    x2: 14.4,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 27.5,
    y1: 26.2,
    x2: 12.8,
    y2: 14.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 19.1,
    y1: 46.2,
    x2: 42.5,
    y2: 46.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 42.5,
    y1: 59.5,
    x2: 45.3,
    y2: 54.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 48.3,
    y1: 21.9,
    x2: 48,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 48,
    y1: 41,
    x2: 47.3,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 55.3,
    y1: 47.5,
    x2: 55,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 57.1,
    y1: 35.4,
    x2: 56.8,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 59.5,
    y1: 38.8,
    x2: 59.4,
    y2: 37.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e3cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eee0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: #8a5ca4 } \n\t\t.s2 { fill: url(#g2);stroke: #ffad5f;stroke-width: .5 } \n\t\t.s3 { fill: #ffce4a } \n\t\t.s4 { fill: url(#g3);stroke: #ffad5f;stroke-width: .5 } \n\t\t.s5 { fill: #f55200 } \n\t\t.s6 { fill: #1e3240 } \n\t\t.s7 { fill: #d0021b } \n\t\t.s8 { fill: #ffffff } \n\t\t.s9 { fill: #ffad5f } \n\t\t.s10 { fill: none;stroke: #000000;stroke-linecap: round;stroke-linejoin: round;stroke-width: .4 } \n\t\t.s11 { fill: url(#g4);stroke: #ffad5f;stroke-width: .5 } \n\t\t.s12 { fill: url(#g5);stroke: #ffad5f;stroke-width: .6 } \n\t\t.s13 { fill: url(#g6) } \n\t\t.s14 { fill: url(#g7) } \n\t\t.s15 { fill: url(#g8) } \n\t\t.s16 { fill: url(#g9) } \n\t\t.s17 { fill: url(#g10) } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m36 64c15.5 0 28-12.5 28-28 0-15.5-12.5-28-28-28-15.5 0-28 12.5-28 28 0 15.5 12.5 28 28 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m27.6 11c0 0-5.6-6-14.8-1.4-12.4 6.2-1.1 31.9 1.7 32.9 2.9 1.1 7.2-24.6 7.2-24.6l5.9-6.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m15 45.9c2.5 0 4.4-2 4.4-4.5 0-2.4-1.9-4.4-4.4-4.4-2.5 0-4.4 2-4.4 4.4 0 2.5 1.9 4.5 4.4 4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m50.7 59.8c-4.2 2.7-9.3 4.2-14.7 4.2-6.5 0-12.4-2.2-17.1-5.8 0.7-2.9 1.5-5.9 1.9-8.3 0.3-1.9 0.3-3.4 0-4.2q-0.4-0.9-0.9-1.8-1.9-3.9-4.5-7.4c-2.7-3.5-4.8-8-4.1-13.2q0.1-0.4 0.1-0.8c2.1-3.8 5.1-7.1 8.7-9.6 4.3-0.6 9.7 1.5 14.9 6.7 7.3 7.1 5.1 10.1 2.6 13.5-1.2 1.6-2.4 3.3-2.8 5.6q1.9 1.3 3.6 2.5l0.4 0.3q0.9 0.6 1.8 1.4c3.8 3.2 7.5 8.1 9.3 14.4q0.3 0.8 0.5 1.5 0.2 0.5 0.3 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m15.2 25.4c-2.9 3.4-5.4 8.5-7.9 3.8-2.5-4.8 3.5-15.4 10.8-18.1 7.4-2.8 20.4-2.3 16.5 6.4 0 0-11.2-1.6-19.4 8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m72 27.8c0 0-37.4 1.4-42.9-6.2-0.1 10.7-9.7 5.9-10.7 7.2-1.6 1.9 2 4.2 8.4 4.2 9.2-0.1 23.1-2 34.2-3.7 4.2-0.6 8.1-1 11-1.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m33.5 22.4c0.4-0.2 0.2-1.2-0.3-2.1-0.6-1-1.3-1.6-1.7-1.3-0.3 0.2-0.2 1.1 0.4 2.1 0.5 0.9 1.2 1.5 1.6 1.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m19 29.9q0 0.1 0 0.2 0.1 0.1 0.2 0.1 0 0.1 0.1 0.2 0.1 0 0.2 0.1 0.4 0.2 0.8 0.3 0.8 0.3 1.6 0.4 1.7 0.3 3.3 0.4c2.3 0.1 4.5 0.1 6.8 0 4.5-0.1 8.9-0.5 13.4-0.9q6.7-0.6 13.4-1.3 3.3-0.4 6.7-0.8c2.2-0.2 4.3-0.5 6.5-0.8-2.2 0.4-4.3 0.7-6.5 1-2.2 0.4-4.4 0.6-6.7 0.9q-6.7 0.8-13.4 1.5c-4.4 0.3-8.9 0.7-13.4 0.7q-3.4 0.1-6.8-0.1-1.6-0.1-3.3-0.4-0.8-0.2-1.6-0.5-0.4-0.1-0.8-0.3-0.1-0.1-0.2-0.2-0.1 0-0.1-0.1-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m19.6 22.6c-2.8 0.8-7.2 2.5-9.2 3.3-2.1 0.9-3.6 2.6-3.1 4.9 0.3 1.2 1.4 1.4 1.4 0.7q0-1.3 0.4-2.6c0.9-2.7 2.2-1.5 4.2-0.9 1.2 0.4 1.8 0.1 2.7-0.7 0.8-0.5 2.5-1.9 3.3-2.5l0.3-2.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m16.7 23.6l1.9 3.9c0.9 1.8 2.9 2.3 4.8 1.8 0.9-0.2 3.1-0.7 3.9-1.2 0.5-0.3 1-0.8 1.3-1.4 0.3-0.6 0.5-1.3 0.5-1.9l0.1-4h0.4l0.7 1.5c0 0 1.8 1.6 6.1 2.7l1-0.1c0.7-0.1 1.4-0.6 1.9-1.2 0.5-0.6 0.8-1.4 0.7-2.2q0-0.2 0-0.3l-0.7-4.3q0-0.3-0.2-0.6-0.1-0.2-0.4-0.4-0.2-0.1-0.5-0.2-0.3 0-0.5 0l-19.5 4.5q-0.5 0.1-0.9 0.4-0.4 0.4-0.6 0.9-0.3 0.5-0.2 1 0 0.6 0.2 1.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s8",
    d: "m18 23.4l1.4 3-0.2 0.2-1.4-3.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s8",
    d: "m18.1 21.4q-0.2 0.2-0.2 0.5-0.1 0.3-0.1 0.6l-0.3 0.1q-0.1-0.4 0-0.8 0.2-0.3 0.4-0.6l0.2 0.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s8",
    d: "m30 20.1l-0.4-1 0.3-0.1 0.4 0.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s8",
    d: "m30.5 21.7l-0.2-0.6 0.3-0.1 0.2 0.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m20.9 20.5l0.1 2.4-1.4 0.8h1.5l0.6 2.7v-2.7l2.1-0.6-2.1-0.2-0.7-2.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m36 63.8c-6.2 0-12-2-16.9-5.7 0.9-3.4 1.6-6.1 1.9-8.1l19.5-6.9c2.6 2.3 7.2 7 9.2 14.3q0.3 0.8 0.5 1.5 0.2 0.4 0.3 0.8-0.7 0.4-1.4 0.8-2.3 1.3-4.7 2c-2.7 0.9-5.5 1.3-8.4 1.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s9",
    d: "m49.9 57.3q0.3 0.8 0.5 1.5 0.2 0.5 0.3 1-0.7 0.5-1.5 0.9-2.3 1.2-4.7 2c-2.7 0.8-5.5 1.3-8.5 1.3-6.5 0-12.4-2.2-17.1-5.9 0.8-2.8 1.5-5.8 1.9-8.3l19.8-6.9c3.8 3.2 7.6 8.1 9.3 14.4zm-9.4-14l-19.3 6.9c-0.3 1.9-0.9 4.5-1.9 7.8 4.9 3.6 10.6 5.6 16.7 5.6 2.8 0 5.7-0.5 8.3-1.3q2.4-0.8 4.7-2 0.6-0.3 1.3-0.7-0.2-0.3-0.3-0.6c-0.1-0.5-0.3-0.9-0.5-1.5-2-7.2-6.4-11.9-9-14.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m37.4 47c0 0 5 4.7 7.9 13.8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s11",
    d: "m20.4 44.9c0 0 5.6-1.7 16.6-0.9 0.8-1.1 0.5-2.2 0.5-3.5 0 0 3.9 0.4 4.8 3.9 0.4 1.8 0.1 4.9-1 5.8-5.5 4.1-20.5-0.3-20.5-0.3 0 0-3.5-2-0.4-5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m43.9 59.9c1.5 0 2.8-1.3 2.8-2.9 0-1.5-1.3-2.8-2.8-2.8-1.6 0-2.9 1.3-2.9 2.8 0 1.6 1.3 2.9 2.9 2.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m48.1 21.9c0.9 0 1.5-0.6 1.5-1.4 0-0.8-0.6-1.5-1.5-1.5-0.8 0-1.4 0.7-1.4 1.5 0 0.8 0.6 1.4 1.4 1.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m47.6 41.1c1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.5-2.6-2.5-1.4 0-2.5 1.1-2.5 2.5 0 1.4 1.1 2.6 2.5 2.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m55.1 47.5c0.7 0 1.3-0.6 1.3-1.3 0-0.7-0.6-1.2-1.3-1.2-0.6 0-1.2 0.5-1.2 1.2 0 0.7 0.6 1.3 1.2 1.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m57 35.4c0.7 0 1.2-0.5 1.2-1.2 0-0.7-0.5-1.2-1.2-1.2-0.7 0-1.3 0.5-1.3 1.2 0 0.7 0.6 1.2 1.3 1.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m59.5 38.8c0.4 0 0.7-0.4 0.7-0.8 0-0.4-0.3-0.8-0.7-0.8-0.5 0-0.8 0.4-0.8 0.8 0 0.4 0.3 0.8 0.8 0.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceImg2);
export default __webpack_public_path__ + "static/media/price_img2.5aef59ec1f50ed91a431d97c62b09982.svg";
export { ForwardRef as ReactComponent };